import { FC } from 'react';
import { Icon as IconZDS, IconName } from '@zapier/design-system';
import { COLOR_KEYS } from '../../constants';

export type Props = {
  iconName: IconName;
};

export const Icon: FC<Props> = ({ iconName }) => {
  return <IconZDS color={COLOR_KEYS.blueJeans} name={iconName} size={50} />;
};
